<footer class="footer pt-5 text-white" style="background-color: #125875; background-image: url('https://eespmdm.edu.pe/user/img/bg/footer-bg.png'); background-size: cover; background-position: center;">
    <div class="container pb-4">
        <div class="row justify-content-between">
            
            <div class="col-xl-3 col-lg-3 col-md-6 mb-4">
                <div class="mb-3 text-center text-md-left">
                    <img src="https://eespmdm.edu.pe/user/img/logo/favicon.png" alt="Logo EESP Marcos Duran Martel" style="max-height: 150px; width: auto;">
                </div>
                <div class="mt-3 text-center text-md-left">
                    <a href="https://www.facebook.com/EESPPMDM/" target="_blank" class="text-white mr-3" style="font-size: 1.5rem;"><i class="fab fa-facebook-f"></i></a>
                    <a href="https://www.instagram.com/eesp_mdm/" target="_blank" class="text-white mr-3" style="font-size: 1.5rem;"><i class="fab fa-instagram"></i></a>
                    <a href="https://youtube.com/@MarcosDuranMartel" target="_blank" class="text-white" style="font-size: 1.5rem;"><i class="fab fa-youtube"></i></a>
                </div>
            </div>

            <div class="col-xl-3 col-lg-3 col-md-6 mb-4">
                <h4 class="font-weight-bold mb-3 text-white">P�ginas</h4>
                <ul class="list-unstyled">
                    <li class="mb-2"><a href="https://eespmdm.edu.pe/nosotros/resena-historica" target="_blank" class="text-white">Historia</a></li>
                    <li class="mb-2"><a href="https://eespmdm.edu.pe/nosotros/mision-y-vision" target="_blank" class="text-white">Misi�n y Visi�n</a></li>
                </ul>
            </div>

            <div class="col-xl-3 col-lg-3 col-md-6 mb-4">
                <h4 class="font-weight-bold mb-3 text-white">Enlaces de inter�s</h4>
                <ul class="list-unstyled">
                    <li class="mb-2"><i class="fas fa-graduation-cap mr-2"></i> <a href="https://alicia.concytec.gob.pe/" target="_blank" class="text-white">ALICIA</a></li>
                    <li class="mb-2"><i class="fas fa-graduation-cap mr-2"></i> <a href="https://renati.sunedu.gob.pe/" target="_blank" class="text-white">RENATI</a></li>
                    <li class="mb-2"><i class="fas fa-graduation-cap mr-2"></i> <a href="https://www.lareferencia.info/es/" target="_blank" class="text-white">La Referencia</a></li>
                </ul>
            </div>

            <div class="col-xl-3 col-lg-3 col-md-6 mb-4">
                <h4 class="font-weight-bold mb-3 text-white">Contactos</h4>
                <ul class="list-unstyled">
                    <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-phone mr-3" style="font-size: 1.2rem;"></i> 
                        <a href="tel:062783814" class="text-white">(062) 783814</a>
                    </li>
                    <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-envelope mr-3" style="font-size: 1.2rem;"></i> 
                        <a href="mailto:direccion@eespmdm.edu.pe" class="text-white">direccion@eespmdm.edu.pe</a>
                    </li>
                    <li class="mb-3 d-flex align-items-start">
                        <i class="fas fa-map-marker-alt mr-3 mt-1" style="font-size: 1.2rem;"></i> 
                        <span>Av. Marcos Duran Martel 200 <br>Amarilis, Hu�nuco</span>
                    </li>
                </ul>
            </div>

        </div>
    </div>

    <div style="background-color: rgba(0, 0, 0, 0.25);">
        <div class="container">
            <div class="row py-3 align-items-center">
                <div class="col-lg-12 text-center">
                    <p class="mb-1 text-white">
                        � 2026 <strong>EESP Marcos Duran Martel</strong>. Todos los derechos reservados.
                    </p>
                    <small class="text-white-50">
                        Desarrollado por <span class="font-weight-bold text-white">Gopixel Systems</span>
                    </small>
                </div>
            </div>
        </div>
    </div>
</footer>